import React, { useCallback, useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";

/**
 *
 * @param fieldName
 * @param defaultFilter
 * @returns {(JSX.Element|{})[]} [textField, filters]
 */
function useJTFilter(fieldName, defaultFilter = {}) {
  const [searchValue, setSearchValue] = useState("");
  const [filters, setFilters] = useState(defaultFilter);
  const filterUpdateTimer = useRef(null);
  const initialDefaultFilter = useRef(defaultFilter);

  useEffect(() => {
    if (JSON.stringify(initialDefaultFilter.current) !== JSON.stringify(defaultFilter)) {
      if (searchValue !== "") {
        setSearchValue("");
      }
      updateFilters("");
    }
  }, [defaultFilter]);

  const updateFilters = useCallback(
    (searchValue) => {
      if (searchValue.length > 0) {
        setFilters({
          ...defaultFilter,
          // TODO <LB>: searchValue should be escaped. Escape %-signs, % => \%
          //            should be escaped on the backend
          [fieldName]: { field: fieldName, operator: "like", value: `%${searchValue}%`, strict: true },
        });
      } else {
        setFilters(defaultFilter);
      }
    },
    [setFilters, defaultFilter, fieldName]
  );

  return [
    <TextField
      color={"primary"}
      onChange={(e) => {
        const value = e.target.value;
        setSearchValue(value);
        if (filterUpdateTimer.current) {
          clearTimeout(filterUpdateTimer.current);
        }
        filterUpdateTimer.current = setTimeout(() => {
          updateFilters(value);
        }, 500);
      }}
      placeholder={"Search"}
      size={"small"}
      value={searchValue}
      variant={"outlined"}
    />,
    filters,
  ];
}

export default useJTFilter;
